module.exports = __webpack_public_path__ + "mainassets/img/tiledots.785f0d24.svg";